import { Attribute, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterType } from '@app/shared/interfaces/front-end-column';
import { BaseProductComponent } from '@product/shared/base-product.component';
import { Condition } from '@product/shared/models/catalog';
import { FilterOperator } from '@product/shared/models/Enums.enum';
import { FilterObject, ListPayload } from '@product/shared/models/ListPayload';
import { catchError, finalize, of, tap } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations'

@Component({
  selector: 'app-dynamic-catalog',
  templateUrl: './dynamic-catalog.component.html',
  styleUrls: ['./dynamic-catalog.component.less'],

  animations: [
    trigger('radioAnimation', [
      state('selected', style({

        transform: 'scale(1.1)'
      })),
      state('unselected', style({

        transform: 'scale(1)'
      })),
      transition('unselected <=> selected', [
        animate('200ms ease-in-out'),
      ]),
    ]),
    // (Smart)
    trigger('filterSectionAnimation', [
      state('void', style({

        height: '0px',
        overflow: 'hidden',
        transform: 'translateY(-20px)',
      })),
      state('*', style({

        height: '*',
        transform: 'translateY(0)',
      })),
      transition('void => *', [
        animate('700ms ease-in-out', style({

          height: '*',
          transform: 'translateY(0)',
        })),
      ]),
      transition('* => void', [
        animate('700ms ease-in-out', style({

          height: '0px',
          transform: 'translateY(-20px)',
        })),
      ]),
    ]),
  ],

})
export class DynamicCatalogComponent extends BaseProductComponent implements OnInit {
  @Output() clearConditionEvent: EventEmitter<void> = new EventEmitter();
  @Output() products = new EventEmitter();
  @Output() filter = new EventEmitter();
  @Output() tabIndexChange = new EventEmitter<string>();
  @Input() mode: string = '';
  @Input() catalogId: number = 0;
  @Output() filtersChanged = new EventEmitter<ListPayload>();
  @Output() isLoadingProduct = new EventEmitter<boolean>();
  @Output() productIdsChange = new EventEmitter<number[]>();
  @Input() objectType: number = 0;

  @Input() typeLabel: string = 'Catalog Type';
  @Input() manualLabel: string = 'Manual';
  @Input() smartLabel: string = 'Smart Catalog';
  conditionType = 'Any';
  isLoading: boolean;
  savedFilters: { [key: string]: FilterObject } | null = {};
  @Input() tabIndex: string = "";

  selectedAttribute: any;
  modalRecords: any;
  isSmartCatalog: boolean;
  isSelectLoading: boolean = false;
  allAttributes: any[] = [];
  isPageLoaded: boolean = false; 
  countCall:number=0;

  ngOnInit() {

    if (this.tabIndex != '') {
      this.isSmartCatalog = this.tabIndex === 'Smart'
    }
  
    
    if (this.mode == 'edit') {
      this.getListPayload(this.catalogId);
    }
    this.isPageLoaded=true;

    // this.typeLabel = this.translate.instant('CatalogType');
    // this.manualLabel = this.translate.instant('Manual');
    // this.smartLabel = this.translate.instant('SmartCatalog');
  }
  filterPayload: ListPayload = {
    SearchValue: '',
    Filters: {

    },
    IsAscend: false,
    SortBy: 'Id',
    PageIndex: 0,

    ApplyAllFilters: false,
    Attributes: []
  };
  tagsList: any[] = [];
  status: any[] = [];
  attributes: Attribute[] = [];

  // button Tabs
  onTabChange(index: any): void {
    this.tabIndex = index;
    if (this.tabIndex == 'Manual') {
      this.filterPayload.Filters = {};
      this.clearCondition();
    }
    this.tabIndexChange.emit(this.tabIndex);

  }
  // Danyicm codeitions
  filterOptions: { [key: number]: any[] } = {};
  groupedFilters: Array<{ filterName: string; items: any[] }> = [];
  sources = [
    { label: 'Attributes', value: 'attributes' },
    { label: 'Categories', value: 'categories' },
    { label: 'Tags', value: 'tags' },
    { label: 'Status', value: 'status' }
  ];

  filters: { [key: string]: { Id: number; Label: string; }[] } = {
    attributes: [],
    categories: [],
    status: [],
    tags: [],

  };

  operators = [
    { label: 'Is equal to', value: 'isEqual' },
    { label: 'Is Empty', value: 'isEmpty' },
    { label: 'Is Not Empty', value: 'isNotEmpty' }
  ];
  conditions: Condition[] = [
    { field: '', operator: '', value: '', source: '' }
  ];
  source: any;
  attributeOptions: any[][] = [];

  Type: string = '';
  updateList(i: any) {
    const condition = this.conditions[i];
    this.source = condition.source;
    const statusCount = this.conditions.filter(c => c.source === 'status').length;
    if (statusCount > 1) {
      this.notification.warning(
        'Duplicate Status Filter',
        'Only one "status" filter is allowed. The duplicate filter has been removed.'
      );
      // this.message.warning('Only one "status" filter is allowed.');
      this.removeCondition(i)
      return;
    }

    if (this.conditions[i].source !== 'attributes') {
      this.conditions[i].value = null;

    }
    // condition.operator = null;

    const previousField = condition.field;
    switch (condition.source) {
      case 'attributes':
        this.getAtribute(i, previousField);
        break;
      case 'categories':
        this.getCategories(i, previousField);
        condition.value = '';
        break;
      case 'tags':
        this.getTags(i, previousField);
        condition.value = '';
        break;
      case 'status':
        this.getStatus(i, previousField);
        break;
      default:
        this.filterOptions[i] = [];
    }
    if (this.filters[condition.source]) {
      this.filterOptions[i] = this.filters[condition.source];

    } else {
      this.filterOptions[i] = [];
    }
  }
  


  updateSelectedCondition(index: number, type: string) {
    let condition = this.conditions[index];
    let fieldId = condition.field;
    let operator = condition.operator as unknown as FilterOperator;
    this.countCall++;
    if(this.countCall > this.conditions.length){
      this.isPageLoaded=false;
    }
    
    if (condition.source === 'attributes') {
      this.getAttributeOptions(index, fieldId);
    }


    if (type === 'operator' && !condition.field) {
      condition['invalidField'] = true;
    } else if (type === 'field') {
      condition['invalidField'] = false;
    }


    if (this.isFieldDisabled(condition)) {
      condition.value = null;
    }



  

    let filterKey = condition.source === 'attributes' ? `${fieldId}#` : condition.source; 
    const keys = Object.keys(this.filterPayload.Filters);
    let oldFilterKey = keys[index];
    if (oldFilterKey) {
      this.filterPayload.Filters[filterKey] = {
        Value: condition.value != null ? condition.value.toString() : '' ,
        Type: FilterType.Number,
        Operator: operator,
        AdditionalInfo: ''
      };
      if (oldFilterKey !== filterKey) {
        delete this.filterPayload.Filters[oldFilterKey];
      }
    }

    this.selectedAttribute = Object.values(this.filterOptions)
      .flat()
      .filter(item => item.Id === fieldId);



    if (filterKey !== `${fieldId}#`) {
      let existingFilter: any = this.filterPayload.Filters[filterKey];

      if (existingFilter) {
        const valueKey = Object.keys(existingFilter).find(
          key => key.toLowerCase() === 'value'
        );

        let existingValues = valueKey && existingFilter[valueKey]
          ? existingFilter[valueKey].split(',')
          : [];


        if (!existingValues.includes(fieldId.toString())) {
          existingValues.push(fieldId.toString());
        }

        this.filterPayload.Filters[filterKey] = {
          Value: existingValues.join(','),
          Type: FilterType.Number,
          Operator: operator,
          AdditionalInfo: ''
        };
      } else {
        this.filterPayload.Filters[filterKey] = {
          Value: fieldId != null ? fieldId.toString() : '',
          Type: FilterType.Number,
          Operator: operator,
          AdditionalInfo: ''
        };
      }
    } else {

      let newFilterValue = condition.value != null ? condition.value.toString() : '';
      let newFilterType = this.selectedAttribute && this.selectedAttribute.length > 0
        ? this.selectedAttribute[0].Type
        : FilterType.Number;

      let existingFilterEntry: FilterObject | undefined = this.filterPayload.Filters[filterKey] as FilterObject;
      let currentValues: string[] = [];

      if (existingFilterEntry && existingFilterEntry.Value) {
        currentValues = existingFilterEntry.Value.split(',');
      }

      if (newFilterValue && !currentValues.includes(newFilterValue)) {
        currentValues.push(newFilterValue);
      }

      if (condition.value === null || condition.value === '' || condition.value === undefined) {  
        const valueToRemove = condition.value != null ? condition.value.toString() : '';
        currentValues = currentValues.filter(val => val !== valueToRemove);
      }

      this.filterPayload.Filters[filterKey] = {
        Value: currentValues.join(','),
        Type: newFilterType,
        Operator: operator,
        AdditionalInfo: ''
      };

    }

    if (type === 'select' && this.conditions[index].typeFiled === 'select' && this.attributeOptions[index]) {
      const selectedOption = this.attributeOptions[index].find(opt => opt.Id === condition.value);
      if (selectedOption) {
        condition['selectedValueLabel'] = selectedOption.Name;
      }
    }


    this.conditions[index].previousFilterKey = filterKey;

    operator = this.conditions[index].operator;

    if (type === 'select' && this.conditions[index].typeFiled === 'select') {
      this.applyFilter();
    } else if (type === 'operator' || operator) {
      const isDisabled = this.isFieldDisabled(condition);
      if (this.source !== 'attributes' || (this.source === 'attributes' && isDisabled)) {
        if (this.conditions[index].field != '') {
          
          this.applyFilter();
         
          
        }
      }
    }
   // this.modeApplyFilter=''
  }



  // updateSelectedCondition(index: number, type: string) {
  //   let condition = this.conditions[index];
  //   let fieldId = condition.field;
  //   let operator = condition.operator as unknown as FilterOperator;
  //   if (type === 'operator' && !condition.field) {
  //     condition['invalidField'] = true;
  //   } else if (type === 'field') {
  //     condition['invalidField'] = false;
  //   }
  //   if (this.isFieldDisabled(condition)) {
  //     condition.value = null;
  //   }
  //   if (condition.source === 'attributes') {
  //     this.getAttributeOptions(index, fieldId);
  //   }
  //   console.log('conditions : ',this.conditions);

  //   let filterKey = condition.source === 'attributes' ? `${fieldId}#` : condition.source;

  //   const keys = Object.keys(this.filterPayload.Filters);


  //   let oldFilterKey = keys[index];
  //   if (oldFilterKey) {

  //     this.filterPayload.Filters[filterKey] = {
  //       Value: condition.value != null ? condition.value.toString() : '',
  //       Type: FilterType.Number,
  //       Operator: operator,
  //       AdditionalInfo: ''
  //     };
  //     if (oldFilterKey !== filterKey) {
  //       delete this.filterPayload.Filters[oldFilterKey];
  //     }
  //   }
  //   this.selectedAttribute = Object.values(this.filterOptions)
  //     .flat()
  //     .filter(item => item.Id === fieldId);

  //   if (filterKey !== `${fieldId}#`) {
  //     let existingFilter: any = this.filterPayload.Filters[filterKey];

  //     if (existingFilter) {
  //       const valueKey = Object.keys(existingFilter).find(
  //         key => key.toLowerCase() === 'value'
  //       );


  //       let existingValues = valueKey && existingFilter[valueKey]
  //         ? existingFilter[valueKey].split(',')
  //         : [];
  //       if (!existingValues.includes(fieldId.toString())) {
  //         existingValues.push(fieldId.toString());
  //       }

  //       this.filterPayload.Filters[filterKey] = {
  //         Value: existingValues.join(','),
  //         Type: FilterType.Number,
  //         Operator: operator,
  //         AdditionalInfo: ''
  //       };
  //     } else {
  //       this.filterPayload.Filters[filterKey] = {
  //         Value: fieldId != null ? fieldId.toString() : '',
  //         Type: FilterType.Number,
  //         Operator: operator,
  //         AdditionalInfo: ''
  //       };
  //     }
  //   } else {



  //     this.filterPayload.Filters[filterKey] = {
  //       Value: condition.value != null ? condition.value.toString() : '',
  //       Type: this.selectedAttribute[0].Type || 0,
  //       Operator: operator,
  //       AdditionalInfo: ''
  //     };

  //   }


  //   if (type === 'select' && this.conditions[index].typeFiled === 'select' && this.attributeOptions[index]) {

  //     const selectedOption = this.attributeOptions[index].find(opt => opt.Id === condition.value);
  //     if (selectedOption) {
  //       condition['selectedValueLabel'] = selectedOption.Name;
  //     }
  //   }

  //   this.conditions[index].previousFilterKey = filterKey;


  //   operator = this.conditions[index].operator;
  //   if (type === 'select' && this.conditions[index].typeFiled === 'select') {

  //     this.applyFilter();
  //   }


  //   else if (type === 'operator' || operator) {
  //     const isDisabled = this.isFieldDisabled(condition)
  //     if (this.source !== 'attributes' || (this.source === 'attributes' && isDisabled)) {
  //       if (this.conditions[index].field != '') {
  //         this.applyFilter();
  //       }

  //     }
  //     // if (this.typeFiled !== 'select' && this.source !== 'attributes') {

  //   }

  // }

  addCondition() {
    const isConditionComplete = (condition: any): boolean => {
      const fieldFilled = condition.field !== '';
      const operatorFilled = condition.operator !== '';
      const sourceFilled = condition.source !== '';

      const valueRequired = !this.isFieldDisabled(condition);
      const valueFilled = condition.value !== '';

      if (valueRequired) {

        return fieldFilled && operatorFilled && valueFilled && sourceFilled;
      } else {

        return fieldFilled && operatorFilled && sourceFilled;
      }
    };


    const allConditionsComplete = this.conditions.every(cond => isConditionComplete(cond));

    if (allConditionsComplete) {

      //  this.conditions.push({ field: '', operator: '', value: '', source: '' });
      this.conditions.push({ field: '', operator: '', value: '', source: '' })

    } else {
      this.message.warning('Please fill in all required fields in the current conditions before adding.');

    }
  }



  removeCondition(index: number) {
    if (this.conditions.length > 1) {
      const condition = this.conditions[index];

      let filterKey = condition.source === 'attributes' ? `${condition.field}#` : condition.source;
      delete this.filterPayload.Filters[filterKey];


      this.conditions.splice(index, 1);
      this.filter.emit(this.filterPayload);
      this.applyFilter();
    }

  }



  clearCondition() {
    this.conditions = [{ field: '', operator: '', value: '', source: '' }];

    this.clearConditionEvent.emit();

    this.filterPayload.Filters = {};
    this.applyFilter();
  }

  onConditionTypeChange() {

    this.filterPayload.ApplyAllFilters = this.conditionType === 'All';
    this.applyFilter();
  }


  applySavedFilter(cond: any): void {

    this.conditions = cond;

    if (this.conditions.length === 0) {
      this.conditions = [
        { field: '', operator: '', value: '', source: '' }
      ];
    }

    this.conditions.forEach((condition, index) => {

      this.updateList(index);


    });

  }
  applyFilter(): void {  
    const hasFilters = Object.keys(this.filterPayload.Filters).some((key) => {
      const filter = this.filterPayload.Filters[key];

      if (!filter) {
        return false;
      }
      return true;
    });
    if (!hasFilters) {
      return;
    }
    if(this.isPageLoaded){
      return;
    }
    this.filterPayload.Filters = { ...this.filterPayload.Filters };
    this.getProducts();
    this.filter.emit(this.filterPayload);
  }

  //   applyFilter(): void {
  //   const hasFilters = Object.keys(this.filterPayload.Filters).some((key) => {
  //     const filter = this.filterPayload.Filters[key];

  //     if (!filter || filter.Value === undefined || filter.Value === null) {
  //       return false;
  //     }

  //     
  //     if (filter.Value !== '') {
  //       return true;
  //     }

  //    
  //     return this.isFieldDisabled(filter); 
  //   });

  //   if (!hasFilters) {
  //     return;
  //   }

  //   this.filterPayload.Filters = {
  //     ...this.filterPayload.Filters,
  //   };
  //   this.getProducts();
  //   this.filter.emit(this.filterPayload);
  // }



  // applyFilter(): void {
  //   
  //   const hasFilters = Object.keys(this.filterPayload.Filters).some(key => {

  //     const filter = this.filterPayload.Filters[key];

  //     return filter && filter.Value !== undefined && filter.Value !== null && filter.Value !== '';
  //   });

  //   if (!hasFilters) {

  //     return;
  //   }

  //   this.filterPayload.Filters = {
  //     ...this.filterPayload.Filters,
  //   };
  //   this.getProducts();
  //   this.filter.emit(this.filterPayload);
  // }

  getProducts() {
    this.isLoadingProduct.emit(true);
    this.commonService
      .getProducts(this.filterPayload)
      .pipe(
        tap((response) => {
          this.modalRecords = response.records;


          const productIds = this.modalRecords.map((record: any) => record.id);
          this.productIdsChange.emit(productIds);


          // productIdsChange
          const count = this.modalRecords.length;

          if (count > 0) {
            this.message.success(`Found ${count} product${count === 1 ? '' : 's'} matching the applied filters.`);
          } else {
            this.message.warning('No products found matching the current filters. Try adjusting your filters.');
          }
          this.products.emit(this.modalRecords);
          this.isLoadingProduct.emit(false);


        }),
        catchError((error) => {
          this.message.error('An error occurred while fetching products. Please try again later.');
          this.isLoadingProduct.emit(false);
          return of([]);
        }),

      )
      .subscribe();
  }


  getListPayload(catalogId: number) {
    this.productCatalog.getListPayload(catalogId, this.objectType).subscribe(
      {
        next: (response: any) => {
          if (response && response.payload) {

            this.filterPayload.Filters = {
              ...response.payload.filters,
            };
            this.filter.emit(response.payload);
            this.transformDrawerPayload(response);
          }


        }
      }
    );
  }




  transformDrawerPayload(filterPayload: any) {
      debugger
    const filters = filterPayload.payload.filters;

    const transformedData = Object.keys(filters).flatMap((key) => {
      const filter = filters[key];

      let source = key;
      let field: number | null = null;
      let value = '';
      if (/\d+#/.test(key)) {
        source = "attributes";
        const match = key.match(/(\d+)#/);
        if (match) {
          field = Number(match[1]);
        }
        value = filter.value;
      }

      if (filter.value.includes(',')) {

        return filter.value.split(',').map((v: string) => ({
          field: Number(v.trim()),
          operator: filter.operator,
          source: source,
          value: value,
        }));

        
      } else {
        let newValue = filter.value;
        if (filter.type == 'Select') {
          newValue = Number(value);
        } else {
          newValue = value;
        }

        return {
          field: field !== null ? field : (Number(filter.value) || null),
          operator: filter.operator,
          source: source,
          value: newValue,

        };
      }
    });

    this.applySavedFilter(transformedData);
  }


  getTags(i: number, previousField: any) {
    this.isSelectLoading = true;
    this.commonService.getOptions().subscribe({
      next: () => {
        this.tagsList = this.commonService.dropDownMetaData['Tags'];
        const transformedTags = this.tagsList.map(tag => ({
          Id: tag.Code,
          Label: tag.Label
        }));
        this.filterOptions[i] = transformedTags;

        if (previousField && this.filterOptions[i].find(item => item.Id === previousField)) {
          this.updateSelectedCondition(i, '');
        } else {
          this.conditions[i].field = null;
          this.conditions[i].value = '';
        }

        this.isSelectLoading = false;

      },
      error: (err) => {
        this.isSelectLoading = false;
        console.error(err);
      }
    });
  }

  getStatus(i: number, previousField: any) {
    this.isSelectLoading = true;
    this.commonService.getOptions().subscribe({
      next: () => {
        this.status = this.commonService.dropDownMetaData['statusId'];
        const transformedStatus = this.status.map(status => ({
          Id: status.Code,
          Label: status.Label
        }));
        this.filterOptions[i] = transformedStatus;

        if (previousField && this.filterOptions[i].find(item => item.Id === previousField)) {
          this.updateSelectedCondition(i, '');
        } else {
          this.conditions[i].field = null;
          this.conditions[i].value = '';
        }

        this.isSelectLoading = false;

      },
      error: (err) => {
        this.isSelectLoading = false;
        console.error(err);
      }
    });
  }


  getCategories(i: number, previousField: any): void {
    this.isSelectLoading = true;
    this.productService.getCategories().subscribe({
      next: (data) => {
        const transformedCat = data.map(cat => ({
          Id: cat.id,
          Label: cat.name
        }));
        this.filterOptions[i] = transformedCat;
        if (previousField && this.filterOptions[i].find(item => item.Id === previousField)) {
          this.updateSelectedCondition(i, '');
        } else {
          this.conditions[i].field = null;
          this.conditions[i].value = '';
        }

        this.isSelectLoading = false;

      },
      error: (error) => {
        this.isSelectLoading = false;
        console.error(error);
      },
    });
  }


  getAtribute(i: number, previousField: any) {
    this.isSelectLoading = true;
    this.attributesService.getAllAtribute().subscribe({
      next: (data: any) => {
        if (data && data.value && Array.isArray(data.value)) {
          this.allAttributes = data.value.filter(
            (attribute: any) => attribute.Type !== 9 && attribute.Type !== 11
          );
          this.filterOptions[i] = this.allAttributes;
          if (previousField && this.filterOptions[i].find(attr => attr.Id === previousField)) {
            this.updateSelectedCondition(i, '');
          } else {
            this.conditions[i].field = null;
            this.conditions[i].value = '';
          }
        }
        this.isSelectLoading = false;

      },
      error: (error) => {
        this.isSelectLoading = false;
        console.error(error);
      }

    }

    );
  }

  getAttributeOptions(index: number, fieldId: any) {
    const selectedAttribute = this.allAttributes.find(attr => attr.Id === fieldId);
    if (selectedAttribute !== undefined && selectedAttribute !== null) {
      this.Type = selectedAttribute.Type;
      // this.getInputType(this.Type);
      this.conditions[index].typeFiled = this.getInputType(this.Type);
      if (selectedAttribute.AttributeOptions) {
        this.attributeOptions[index] = selectedAttribute.AttributeOptions;
      }
    } else {
      this.Type = '';
      this.attributeOptions[index] = [];
      // this.conditions[index].typeFiled = 'text';
    }

  }
  getInputType(typeId: any): string {
    switch (typeId) {
      case 0: return 'number';
      case 1: return 'text';
      case 2: return 'date';
      case 3: return 'Time';
      case 6: return 'select';
      case 7: return 'checkbox';
      default: return 'text';
    }
  }

  // typeFiled: string = '';
  // getInputType(typeId: any): string {
  //   switch (typeId) {
  //     case 0:
  //       this.typeFiled = 'number';
  //       break;
  //     case 1:
  //       this.typeFiled = 'text';
  //       break;
  //     case 2:
  //       this.typeFiled = 'date';
  //       break;
  //     case 3:
  //       this.typeFiled = 'Time';
  //       break;
  //     case 6:
  //       this.typeFiled = 'select';
  //       break;
  //     case 7:
  //       this.typeFiled = 'checkbox';
  //       break;
  //     default:
  //       this.typeFiled = 'text';

  //   }
  //   return this.typeFiled;
  // }
  onFieldBlur(i: any) {
    if (this.source === 'attributes') {
      this.applyFilter();
    }
  }

  isApplyDisabled(): boolean {
    return !this.conditions.some(
      condition =>
        condition.source &&
        condition.field &&
        condition.operator
    );
  }

  isFieldDisabled(condition: any): boolean {
    const operator = condition.operator;

    return condition.source !== 'attributes'
      || (condition.source === 'attributes' && (operator === 'isNotEmpty' || operator === 'isEmpty'));
  }

  trackByIndex(index: number, condition: any) {
    return index;
  }

}
